export const Visibility = Object.freeze({
  OPENED: {},
  CLOSED: {
    display: 'none'
  }
})
